import {css} from "lit";

export const videoStyles = css`
  :host {
    max-width: var(--sbkCoreContentAreaBodyMaxWidth);
    display: block;
  }
    
  .video-container {
    height: 0;
    margin-bottom: 16px;
    overflow: hidden;
    padding-bottom: 56.25%;
    padding-top: 0;
    position: relative;

    iframe {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      border-radius: var(--sbkCoreBorderRadiusLg);
    }

  }

  video {
    margin-bottom: 16px;
    max-width: 100%;
    width: 100%;
      border-radius: var(--sbkCoreBorderRadiusLg);
  }
`;
